import * as React from 'react'
import {Dropdown} from 'wix-ui-tpa/Dropdown'
import {classes} from './styled-dropdown.st.css'
import {StyledDropdownProps} from '.'

export const StyledDropdown = ({placeholder, options, onChange}: StyledDropdownProps) => (
  <Dropdown className={classes.dropdown} upgrade placeholder={placeholder} options={options} onChange={onChange} />
)
